import { render, staticRenderFns } from "./backAddress.vue?vue&type=template&id=78ad3ab6&scoped=true"
import script from "./backAddress.vue?vue&type=script&lang=js"
export * from "./backAddress.vue?vue&type=script&lang=js"
import style0 from "./backAddress.vue?vue&type=style&index=0&id=78ad3ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad3ab6",
  null
  
)

export default component.exports